import {
  chakraComponents,
  ClearIndicatorProps,
  GroupBase,
} from 'chakra-react-select';
import { Option } from 'types/general.types';
import React from 'react';
import { ReactComponent as CloseIcon } from 'resources/images/close.svg';

export const ClearIndicator = (
  props: ClearIndicatorProps<Option, false, GroupBase<Option>>
) => {
  const {
    isFocused,
    hasValue,
    selectProps: { isClearable },
  } = props;

  if (isFocused && hasValue && isClearable) {
    return (
      <chakraComponents.ClearIndicator {...props}>
        <CloseIcon />
      </chakraComponents.ClearIndicator>
    );
  }

  return null;
};
